import React from "react";
import { 
  Toolbar, 
  Typography, 
  Button, 
  IconButton, 
  Stack
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar } from "../Helper/DashboardNavHelper";
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import DarkModeToggle from "./Switch/DarkModeToggle";

const DashboardNavbar = ({ userEmail, onLogout, navState, openNav }) => {
  return (
    <AppBar 
      position="fixed" 
      open={navState} 
      elevation={0}
      sx={{ 
        bgcolor: 'primary',
        color: 'primary',
        borderBottom: 1,
        borderColor: 'divider'
      }}
    >
      <Toolbar>
        {/* Menu Button */}
        <IconButton
          color="inherit"
          onClick={() => openNav(true)}
          edge="start"
          sx={{ 
            mr: 2,
            display: navState ? 'none' : 'flex'
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Logo/Brand */}
        <Stack 
          direction="row" 
          spacing={1} 
          alignItems="center" 
          sx={{ flexGrow: 1 }}
        >
          <SchoolOutlinedIcon />
          <Typography color="inherit" fontWeight={800} variant="h6">
            UnifyEdu
          </Typography>
          {userEmail && (
            <Typography 
              variant="caption" 
              sx={{ 
                ml: 2, 
                opacity: 0.8,
                display: { xs: 'none', md: 'block' }
              }}
            >
              Welcome, {userEmail}
            </Typography>
          )}
        </Stack>

        {/* Right Side Controls */}
        <Stack direction="row" spacing={2} alignItems="center">
          <DarkModeToggle />
          <Button 
            variant="contained" 
            color="secondary"
            onClick={onLogout}
            size="small"
          >
            Logout
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;